import { Popconfirm, message, Tooltip } from "antd";
import React, { Component } from "react";
import axios from "axios";
import {
  ButtonItem,
  HeaderActions,
  SegmentedItem,
  TableItemDinamico,
} from "../../../../Components/Items";
import { connect } from "react-redux";
import {
  StopOutlined,
  EditOutlined,
  CheckCircleOutlined,
  TeamOutlined,
  BookOutlined,
  ReadOutlined,
  ImportOutlined,
} from "@ant-design/icons";
import EscuelaModal from "../EscuelaModal/EscuelaModal";
import GrupoEscuelaModal from "../GrupoEscuelaModal/GrupoEscuelaModal";
import NivelesEducativosModal from "../NivelesEducativosModal/NivelesEducativosModal";
import ProgramasEducativosModal from "../ProgramasEducativosModal/ProgramasEducativosModal";

class EscuelasTab extends Component {
  tableRef = null;
  state = {
    todasEscuelas: [],
    loading: false,
    valor: 1,
    totalRecords: 0,
    modalEscuelaVisible: false,
    escuelaSeleccionada: null,
    modalGrupoVisible: false,
    grupoEscuelaIdInicial: null,
    modalNivelesVisible: false,
    modalProgramasVisible: false,
  };

  consultarEscuelas = (params) => {
    this.setState({ loading: true });
    axios
      .post(
        "escuelas/selectTodasEscuelas",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasEscuelas: res.data.data,
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({ todasEscuelas: [], totalRecords: 0, loading: false });
        }
      });
  };

  abrirModalAgregar = () => {
    this.setState({ modalEscuelaVisible: true, escuelaSeleccionada: null });
  };

  abrirModalEditar = (escuela) => {
    this.setState({
      modalEscuelaVisible: true,
      escuelaSeleccionada: escuela,
    });
  };

  cerrarModalEscuela = (recargar = false) => {
    this.setState({ modalEscuelaVisible: false, escuelaSeleccionada: null });
    if (recargar && this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  };

  abrirModalGrupo = (escuelaId) => {
    this.setState({
      modalGrupoVisible: true,
      grupoEscuelaIdInicial: escuelaId,
    });
  };

  cerrarModalGrupo = () => {
    this.setState({ modalGrupoVisible: false, grupoEscuelaIdInicial: null });
  };

  deshabilitarEscuela = (id) => {
    axios
      .post(
        "escuelas/deshabilitarEscuela",
        { escuelaId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) message.success("Escuela deshabilitada");
        else message.error("Sucedió un error y no se pudo deshabilitar");
        if (this.tableRef)
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  };

  habilitarEscuela = (id) => {
    axios
      .post(
        "escuelas/habilitarEscuela",
        { escuelaId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) message.success("Escuela habilitada");
        else message.error("Sucedió un error y no se pudo habilitar");
        if (this.tableRef)
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  };

  render() {
    const columns = [
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        sorter: true,
        buscar: "clave",
        width: 120,
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: true,
        buscar: "nombre",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: true,
        buscar: "descripcion",
        ellipsis: true,
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "20%",
        onHeaderCell: () => ({
          style: { textAlign: "center", padding: "4px" },
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: "center", padding: "4px" },
        }),
        render: (value, record) => (
          <div className="acciones-container">
            <Tooltip title={this.props.permisoEditarEscuela ? "Editar Escuela" : "No disponible"} placement="top">
              <ButtonItem
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                disabled={!this.props.permisoEditarEscuela}
                onClick={() => this.props.permisoEditarEscuela && this.abrirModalEditar(record)}
              />
            </Tooltip>
            <Tooltip title={this.props.permisoAgregarGrupoEscuela ? "Agregar Grupo a esta escuela" : "No disponible"} placement="top">
              <ButtonItem
                type="default"
                size="small"
                azul
                icon={<TeamOutlined />}
                disabled={!this.props.permisoAgregarGrupoEscuela}
                onClick={() => this.props.permisoAgregarGrupoEscuela && this.abrirModalGrupo(value._id)}
              />
            </Tooltip>
            {value.estado === 1 ? (
              <Popconfirm
                title="¿Seguro que quieres deshabilitar esta escuela?"
                onConfirm={() => this.deshabilitarEscuela(value._id)}
                okText="Si"
                cancelText="No"
                disabled={!this.props.permisoDeshabilitarEscuela}
              >
                <Tooltip title={this.props.permisoDeshabilitarEscuela ? "Deshabilitar Escuela" : "No disponible"} placement="top">
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                    disabled={!this.props.permisoDeshabilitarEscuela}
                  />
                </Tooltip>
              </Popconfirm>
            ) : (
              <Popconfirm
                title="¿Seguro que quieres habilitar esta escuela?"
                onConfirm={() => this.habilitarEscuela(value._id)}
                okText="Si"
                cancelText="No"
                disabled={!this.props.permisoDeshabilitarEscuela}
              >
                <Tooltip title={this.props.permisoDeshabilitarEscuela ? "Habilitar Escuela" : "No disponible"} placement="top">
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                    disabled={!this.props.permisoDeshabilitarEscuela}
                  />
                </Tooltip>
              </Popconfirm>
            )}
          </div>
        ),
      },
    ];

    return (
      <>
        <div
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            justifyContent: "flex-end",
            marginBottom: 10,
            flexWrap: "wrap",
          }}
        >
          <SegmentedItem
            options={[
              { label: "Activo", value: 1 },
              { label: "Deshabilitado", value: 2 },
              { label: "Todos", value: 3 },
            ]}
            onChange={(value) => {
              if (this.tableRef)
                this.tableRef.updateExternalFilters({ valor: value });
              this.setState({ valor: value });
            }}
            value={this.state.valor}
          />
          {this.props.permisoNivelesProgramasEscuelas && (
            <>
              <HeaderActions>
                <ButtonItem
                  type="default"
                  petroleo
                  className="botonAgregar"
                  icon={<ImportOutlined />}
                  onClick={() =>
                    this.props.history.push("/panel/importarProgramasEducativos")
                  }
                >
                  Importar Programas
                </ButtonItem>
                <ButtonItem
                  type="default"
                  className="botonAgregar"
                  lila
                  icon={<ImportOutlined />}
                  onClick={() =>
                    this.props.history.push("/panel/importarNivelesEducativos")
                  }
                >
                  Importar Niveles
                </ButtonItem>
                <ButtonItem
                  type="default"
                  className="botonAgregar"
                  icon={<ImportOutlined />}
                  onClick={() => this.props.history.push("/panel/importarEscuelas")}
                >
                  Importar Escuelas
                </ButtonItem>
              </HeaderActions>

              <ButtonItem
                type="default"
                lila
                className="botonAgregar"
                icon={<BookOutlined />}
                onClick={() => this.setState({ modalNivelesVisible: true })}
              >
                Niveles Educativos
              </ButtonItem>

              <ButtonItem
                type="default"
                petroleo
                className="botonAgregar"
                icon={<ReadOutlined />}
                onClick={() => this.setState({ modalProgramasVisible: true })}
              >
                Programas Educativos
              </ButtonItem>

              <ButtonItem
                type="primary"
                className="botonAgregar"
                onClick={this.abrirModalAgregar}
              >
                Agregar Escuela
              </ButtonItem>
            </>
          )}
        </div>

        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarEscuelas}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasEscuelas}
          columns={columns}
          onRow={(record) => ({
            onDoubleClick: () =>
              this.props.permisoEditarEscuela && this.abrirModalEditar(record),
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
          filterStorageKey={"escuelasFiltrosTabla" + this.props.empresaId}
        />

        <EscuelaModal
          visible={this.state.modalEscuelaVisible}
          escuela={this.state.escuelaSeleccionada}
          cerrarModal={this.cerrarModalEscuela}
        />
        <GrupoEscuelaModal
          visible={this.state.modalGrupoVisible}
          escuelaIdInicial={this.state.grupoEscuelaIdInicial}
          cerrarModal={this.cerrarModalGrupo}
        />
        <NivelesEducativosModal
          visible={this.state.modalNivelesVisible}
          cerrarModal={() => this.setState({ modalNivelesVisible: false })}
        />
        <ProgramasEducativosModal
          visible={this.state.modalProgramasVisible}
          cerrarModal={() => this.setState({ modalProgramasVisible: false })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoNivelesProgramasEscuelas:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3a63895863914405745f"
    )?.activado,
  permisoEditarEscuela:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3a8d8958639144057464"
    )?.activado,
  permisoAgregarGrupoEscuela:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3ab68958639144057468"
    )?.activado,
  permisoDeshabilitarEscuela:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3ad9895863914405746c"
    )?.activado,
});

export default connect(mapStateToProps)(EscuelasTab);
